import React, { useEffect, useRef, useState } from 'react';
import { modelTypeMap, quickModelShowType } from '../../../../constants';
import CardShimmer from '../../CardShimmer';
import InnerMore from '../../InnerMore';
import ScrollListener from '../../ScrollListener';
import LoadMore from '../../../base/LoadMore';
import { setModelsModalState, useModelsModalState } from '../../../../store/state';
import { pageSize, useCateListFetch } from './fetchHander';
import { v4 } from 'uuid';
import { EmptyState } from '../../../base/modelLib/EmptyState';
import { applyModel } from '../../../../helpers';
import ModelCard from '../../ModelCard';
import { Divider } from '@mantine/core';
import { translate } from '@shakkerai/util-i18n';
import { useTempState } from '@starflow/app/store';

const L1Wrapper = (props) => {
  const { cols, modelType, ratio, menus, menuPath, setMenus } = props;
  const { loading, fetchList, fetchCollect } = useCateListFetch(menuPath, modelType);
  const [loadmore, setLoadMore] = useState(false);
  const catesModels = useModelsModalState('catesModels');
  const baseTypes = useModelsModalState('baseTypes');
  const [list, setList] = useState([]);
  const [hasMore, setHasMore] = useState(true); // 到底了
  const globalMode = useTempState('globalMode');
  const turnPageErrorFlag = useRef(null);

  useEffect(() => {
    setHasMore(true);
    const key = `${menuPath.level}-${menuPath.menu.code}`;
    const target = catesModels[key];
    if (target) {
      // TODO 这里需要考虑默认获取的前两组数据都是空，需要递归获取剩下的类别的模型，如果都是空，才是真的为空
      // 业务上目前不存在这个case，有时间可以完善这里代码逻辑
      setList(target);
    }
  }, [catesModels, menuPath]);
  const onModelScroll = async () => {
    if (loading || loadmore) return;
    const nextChild = list.find((li) => li.type !== quickModelShowType.appendTagCode && !li?.data?.fetched);

    if (nextChild) {
      setLoadMore(true);
      const data =
        nextChild.type === quickModelShowType.collection
          ? await fetchCollect({
              page: 1,
              pageSize,
              collectionId: nextChild.code,
              requestId: v4(),
              ...nextChild,
            })
          : await fetchList({
              modelType: modelTypeMap[modelType],
              page: 1,
              pageSize,
              requestId: v4(),
              tagCode: nextChild.code,
              ...nextChild,
            });
      const newList = list.map((item) => {
        if (item.code === nextChild.code) {
          return {
            ...item,
            data,
          };
        }
        return item;
      });
      setModelsModalState({
        catesModels: {
          ...catesModels,
          [`${menuPath.level}-${menuPath.menu.code}`]: newList, // key这样拼接是防code重复
        },
      });
    } else {
      if (turnPageErrorFlag.current) return; // 翻页接口异常兜底
      const nextChild = list.find((li) => li.type === quickModelShowType.appendTagCode);
      const listLen = nextChild.data?.list?.length;
      const total = nextChild.data?.total;
      if (listLen >= total) return;
      setLoadMore(true);
      const page = nextChild.data?.page;
      const data = await fetchList({
        modelType: modelTypeMap[modelType],
        page: page ? page + 1 : 1,
        pageSize: 30,
        requestId: nextChild.data?.requestId ?? v4(),
        baseTypes: globalMode === 'pro' ? baseTypes : ['19'],
        tagCode: nextChild.code,
        ...nextChild,
      });
      if (!data?.list) {
        turnPageErrorFlag.current = true;
        setLoadMore(false);
        return;
      }
      const newList = list.map((item) => {
        if (item.code === nextChild.code) {
          return {
            ...item,
            data: {
              ...data,
              list: (nextChild.data?.list ?? []).concat(data.list),
            },
          };
        }
        return item;
      });
      setModelsModalState({
        catesModels: {
          ...catesModels,
          [`${menuPath.level}-${menuPath.menu.code}`]: newList, // key这样拼接是防code重复
        },
      });
    }
    setLoadMore(false);
  };

  useEffect(() => {
    // 到底判断条件： 分组展示的数据全部请求完毕+无限滚动数据已经拉取完毕
    let noAppendFetched = list.slice(0, -1).every((li) => li.data?.fetched);
    const appendData = list.slice(-1)[0]?.data;
    let allAppendFetched = appendData?.list?.length >= appendData?.total;
    if (noAppendFetched && allAppendFetched) {
      setHasMore(false);
    }
  }, [list]);

  if (loading) {
    return (
      <div className="flex flex-wrap">
        <CardShimmer ratio={ratio} cols={cols} />
      </div>
    );
  }
  const hasData = (list ?? []).some((li) => li?.data?.list?.length > 4);
  if (!hasData) return <EmptyState />;

  const normalList = list.slice(0, -1).filter((li) => li?.data?.list?.length);
  const appendList = list.slice(-1)[0]?.data?.list ?? [];
  return (
    <ScrollListener className="flex flex-wrap pl-4 !h-auto" onScroll={() => onModelScroll()}>
      {normalList.map((item, idx) => {
        return <InnerMore data={item.data} key={idx} ratio={ratio} {...props} />;
      })}
      {appendList.length ? (
        <>
          <div className="flex w-full justify-between pr-4 pb-4 ">
            <div className="text-[#2D2D2D] text-lg font-medium">{list.slice(-1)[0].label}</div>
          </div>
          {appendList.map((item, idx) => {
            return (
              <ModelCard
                data={item}
                key={idx}
                ratio={ratio}
                cols={cols}
                showTag={true}
                query={''}
                onClick={applyModel}
              />
            );
          })}
          {!hasMore && (
            <div className="w-full">
              <Divider
                label={translate('history_bottom')}
                color="#EBEBEB"
                className="w-[40%] m-auto"
                styles={{ label: { fontSize: '12px', color: '#969696', lineHeight: '12px' } }}
              />
            </div>
          )}
        </>
      ) : null}
      {loadmore && <LoadMore />}
    </ScrollListener>
  );
};

export default L1Wrapper;
